import React from 'react';

import {
  Typography,
} from '@material-ui/core';

import { createMuiTheme } from '@material-ui/core/styles';
import * as constants from './config/constants';

import classes from './css/getCSS';

import ratibhai from './assets/img/ratibhai.jpg';
import khemka from './assets/img/khemka.jpg';


export const themeColors = {
  [constants.MAIN_SITE_HOST]: {
    primaryMain: '#e85a71',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.RAJKOT_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.AMD_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.SURAT_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.KOLKATA_SITE_HOST]: {
    primaryMain: '#e85a71',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.LOHANA_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.DIVORCEE_SITE_HOST]: {
    primaryMain: '#e85a71',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.NRI_SITE_HOST]: {
    primaryMain: '#AB47BC',
    primaryLight: '#ad65ba',
    primaryDark: '#bb6bc9',
  },
  [constants.JAIN_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.GORMAHARAJ_HOST]: {
    primaryMain: '#AB47BC',
    primaryLight: '#ad65ba',
    primaryDark: '#bb6bc9',
  },
  [constants.SHAADIYOG_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
};


export const getTheme = () => {
  let theme = null;

  theme = createMuiTheme({
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiInput: {
        disableUnderline: true,
      },
    },
    typography: {
      fontFamily: 'Source Sans Pro',
    },
    palette: {
      primary: {
        main: themeColors[window.location.host].primaryMain,
        light: themeColors[window.location.host].primaryLight,
        dark: themeColors[window.location.host].primaryDark,
        contrastText: '#fff',
      },
      info: {
        main: '#26C6DA',
        light: '#51d1e1',
        dark: '#1a8a98',
        contrastText: '#000',
      },
      success: {
        main: '#009688',
        light: '#33ab9f',
        dark: '#00695f',
        contrastText: '#fff',
      },
      warning: {
        main: '#ffc107',
        light: '#ffcd38',
        dark: '#b28704',
        contrastText: '#000',
      },
      danger: {
        main: '#F44336',
        light: '#f6685e',
        dark: '#aa2e25',
        contrastText: '#fff',
      },
      secondary: {
        main: '#607D8B',
        light: '#7f97a2',
        dark: '#435761',
        contrastText: '#fff',
      },
    },
  });

  return theme;
};


export const getHomeCover = () => {
  let cover = null;
  if (window.location.host === constants.MAIN_SITE_HOST) {
    cover = require('./assets/backs/back8.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.RAJKOT_SITE_HOST) {
    cover = require('./assets/backs/back9.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.AMD_SITE_HOST) {
    cover = require('./assets/backs/back9.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SURAT_SITE_HOST) {
    cover = require('./assets/backs/back9.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    cover = require('./assets/backs/back4.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    cover = require('./assets/backs/back6.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    cover = require('./assets/backs/back7.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.KOLKATA_SITE_HOST) {
    cover = require('./assets/backs/back7.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  return cover;
};


export const getLogo = () => {
  let logo = null;
  if (window.location.host === constants.MAIN_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.RAJKOT_SITE_HOST) {
    logo = require('./assets/img/logos/main.png');  // eslint-disable-line
  }
  if (window.location.host === constants.AMD_SITE_HOST) {
    logo = require('./assets/img/logos/main.png');  // eslint-disable-line
  }
  if (window.location.host === constants.SURAT_SITE_HOST) {
    logo = require('./assets/img/logos/main.png');  // eslint-disable-line
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.KOLKATA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    logo = require('./assets/img/logos/sy.png');  // eslint-disable-line
  }
  return logo;
};


export const getHomeCaption = () => {
  let caption = null;
  if (window.location.host === constants.MAIN_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
      </React.Fragment>
    );
  }
  if (window.location.host === constants.RAJKOT_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Rajkot Bureau
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.AMD_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Ahmedabad Bureau
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.SURAT_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Surat Bureau
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Lohanas
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Divorcees
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          NRIs
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Jains
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.KOLKATA_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Kolkata Bureau
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Elite Matrimony
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Your Story Starts
          <br />
          With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Inspired by our father Late Shri Bhawanishankarji Khemka
        </Typography>
        <br />
      </React.Fragment>
    );
  }

  return caption;
};


export const detectIE = () => {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};


export const getKakaImage = () => {
  if (window.location.host === constants.SHAADIYOG_HOST) {
    return khemka;
  }
  return ratibhai;
};


export const getKakaImageDynamic = (content = 'anjal') => {
  if (content === 'sy') {
    return khemka;
  }
  return ratibhai;
};


export const getKakaTagline = () => {
  if (window.location.host === constants.SHAADIYOG_HOST) {
    return '"He gave us the slogan \'Don\'t worry about the problem, find a solution and keep going\'. We all at Khemka family are excelling following principles and values he laid down on us. \n His blessings are always there with us..."';
  }
  // eslint-disable-next-line consistent-return
  return '"Late Shri Ratibhai Sodha (Jayendrabhai\'s Father) started Free Matrimony Service for Lohana community families to help them find suitable match for their sons/daughters..."';
};



// WEBPACK FOOTER //
// ./src/util.js